module.exports = __webpack_public_path__ + "static/media/37.7f903782.jpg";